export const iconFontAwesomeEducationBookOpen = (
	<i className="fa-solid fa-book-open"></i>
);
